import { Component } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ShowAllAppointmentsModalComponent } from '../show-all-appointments-modal/show-all-appointments-modal.component';
import { AddTasksModalComponent } from '../add-tasks-modal/add-tasks-modal.component';
import { AvailableScheduleModalComponent } from '../available-schedule-modal/available-schedule-modal.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationTaskModalService } from '../confirmation-task-modal/confirmation-task-modal.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EventInput } from '@fullcalendar/core';

@Component({
  selector: 'split-dashboard-menu',
  templateUrl: './dashboard-menu.component.html',
  styleUrls: ['./dashboard-menu.component.scss']
})
export class DashboardMenuComponent {
  public resources: any[] = [
    {
      id: '1',
      title: 'Ana Carolina Pereira',
      image: "/assets/avatar/Avatar.png",
      description: "Fisioterapeuta - Unidade Barreiro"
    },
    {
      id: '2',
      title: 'Carlos Lopes',
      image: "/assets/avatar/Avatar.png",
      description: "Fisioterapeuta - Unidade Barreiro 2"
    },
    {
      id: '5',
      title: 'Carlos Lopes',
      image: "/assets/avatar/Avatar.png",
      description: "Fisioterapeuta - Unidade Barreiro 2"
    },
    {
      id: '6',
      title: 'Carlos Lopes',
      image: "/assets/avatar/Avatar.png",
      description: "Fisioterapeuta - Unidade Barreiro 2"
    },
    {
      
      id: '7',
      title: 'Carlos Lopes',
      image: "/assets/avatar/Avatar.png",
      description: "Fisioterapeuta - Unidade Barreiro 2"
    }
  ];

  events: EventInput[] = [
    { 
      title: 'Reunião', 
      client: 'Danillo do Carmo Muniz Araujo', 
      start: '2024-02-27T10:00:00', 
      end: '2024-02-27T12:00:00', 
      resourceId: '1' 
    },
    { 
      title: 'Entrevista', 
      borderColor: "red", 
      backgroundColor:"red", 
      client: 'Danillo do Carmo Muniz Araujo', 
      start: '2024-02-27T14:00:00', 
      end: '2024-02-27T15:00:00', 
      resourceId: '1' 
    },
    {
      start: '2024-02-27T10:00:00',
      end: '2024-02-27T15:00:00',
      display: 'background',
      backgroundColor: "red",
      resourceId: '1'
    }
  ];
  form: FormGroup = this.fb.group({
    cidade:[''],
    unidade:[''],
    especialidade:[''],
    profissional:[''],
    servico:[''],
    exame:['']
  });
  constructor(
    private fb: FormBuilder,
    public modalService: ModalService, 
    public dialogService: DialogService,
    public confirmationTaskModalService: ConfirmationTaskModalService
    ) {
    
  }
  sidebarVisible:boolean = false;
  
  onSelect(e:any) {

  }
  openModalShowAll() {
    this.modalService.show(ShowAllAppointmentsModalComponent, `Tarefas`,[]);
  }
  openAddTasks() {
    this.modalService.show(AddTasksModalComponent , 'Adicionar Tarefas', []);
  }
  openConfirmationModalTasks() {
    this.confirmationTaskModalService.openModal();
  }
  openAvailableSchedule() {
    this.dialogService.open(AvailableScheduleModalComponent, {
      width: '98%',
      height: '100%',
      style: {
        'height': '97vh',
        'max-height': '98vh',
        //'padding' : '0 1.5rem 0.9rem 1.5rem'
      },
      // contentStyle: { 'border-radius': '6px' },
      baseZIndex: 10000,
      dismissableMask: true,
      styleClass: 'dialogComponent dialog-header-disabled' ,
      data: []
    });
  }
 
}
